export default __webpack_public_path__ + "static/media/logo.6e1561c2.svg";